import type { TBillingInterval } from "@/types/app";

/** What the buyer ticked on the pricing page, recorded on purchase. */
export type TAbmConsent = {
  text: string;
  productIds: string[];
  interval: TBillingInterval;
  acceptedAt: string;
};

const STORAGE_KEY = "pendingAbmConsent";

// Session-scoped so the tick survives the logged-out detour through /auth.
export function stashAbmConsent(consent: TAbmConsent) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch {
    // Storage blocked: purchase still goes ahead, the consent just isn't recorded.
  }
}

export function takeAbmConsent(): TAbmConsent | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as TAbmConsent) : undefined;
  } catch {
    return undefined;
  }
}
